"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerBase = exports.EMPTY_TRACK_ID = void 0;
var player_utils_1 = require("@24i/player-utils");
var types_1 = require("./types");
var PlayerStates_1 = require("./PlayerStates");
var support_1 = require("./support");
exports.EMPTY_TRACK_ID = 'empty-text-track-id';
var ON_LIVE_EDGE_THRESHOLD = 8000;
var PlayerBase = (function () {
    function PlayerBase() {
        var _this = this;
        this.events = new player_utils_1.EventsManager();
        this.addEventListener = this.events.addEventListener;
        this.removeEventListener = this.events.removeEventListener;
        this.triggerEvent = function (eventName, payload) { return _this.events.triggerEvent(eventName, payload); };
        this.supportedFormats = new support_1.BaseSupportedFormats();
        this.startPosition = 0;
        this.startPositionType = types_1.SeekType.TIMESHIFT;
        this.wasVideoTrackSelected = false;
        this.wasAudioTrackSelected = false;
        this.wasTextTrackSelected = false;
        this.abrTrackRestrictions = {};
        this.state = PlayerStates_1.PlayerStates.INIT;
        this.hasLoadedMetadata = false;
    }
    Object.defineProperty(PlayerBase.prototype, "continueInBackground", {
        get: function () {
            return false;
        },
        set: function (_) {
        },
        enumerable: false,
        configurable: true
    });
    PlayerBase.prototype.initializePlayer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, preloadMode, source, autoPlay, muted, startPosition, startPositionType, abrStrategy, continueInBackground, performanceTweaks, allowPlay;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.state = PlayerStates_1.PlayerStates.INIT;
                        if (this.initializationConfig) {
                            _a = this.initializationConfig, preloadMode = _a.preloadMode, source = _a.source, autoPlay = _a.autoPlay, muted = _a.muted, startPosition = _a.startPosition, startPositionType = _a.startPositionType, abrStrategy = _a.abrStrategy, continueInBackground = _a.continueInBackground, performanceTweaks = _a.performanceTweaks, allowPlay = _a.allowPlay;
                            this.preloadMode = preloadMode;
                            this.source = source;
                            this.autoPlay = autoPlay;
                            this.muted = muted;
                            this.startPosition = startPosition;
                            this.startPositionType = startPositionType;
                            this.abrStrategy = abrStrategy;
                            this.continueInBackground = continueInBackground;
                            this.performanceTweaks = performanceTweaks;
                            this.allowPlay = allowPlay !== false;
                        }
                        return [4, this.supportedFormats.initialize()];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    PlayerBase.prototype.setMetadata = function (metadata) {
        this.source = __assign(__assign({}, this.source), { metadata: __assign({ title: '', description: '', programEnd: undefined, programStart: undefined }, metadata) });
    };
    PlayerBase.prototype.getMetadata = function () {
        var _a;
        return ((_a = this.source) === null || _a === void 0 ? void 0 : _a.metadata) || {};
    };
    PlayerBase.prototype.setDrmProtection = function (drmConfig) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var drmSupported, manifest, manifestDrms, allowedFormatted;
            return __generator(this, function (_c) {
                if (drmConfig && drmConfig.packageName) {
                    drmSupported = this.supportedFormats.isSupported({
                        type: (_a = this.source) === null || _a === void 0 ? void 0 : _a.mimeType,
                        drm: drmConfig.packageName,
                        provider: drmConfig.integration,
                    });
                    if (!drmSupported) {
                        manifest = this.supportedFormats.findManifest((_b = this.source) === null || _b === void 0 ? void 0 : _b.mimeType);
                        manifestDrms = !manifest ? [] : manifest.drm;
                        allowedFormatted = manifestDrms.flatMap(function (d) { return d.keySystems; }).join(', ') ||
                            'none';
                        throw new Error("An unsupported DRM system is used " + drmConfig.packageName + ". " +
                            ("Supported key systems formats are: " + allowedFormatted));
                    }
                }
                return [2];
            });
        });
    };
    PlayerBase.prototype.preLoadChecks = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var type, formatSupported, allowedMimeTypes, allowedFormatted;
            return __generator(this, function (_d) {
                if (!((_a = this.source) === null || _a === void 0 ? void 0 : _a.url) && !((_b = this.source) === null || _b === void 0 ? void 0 : _b.ssai)) {
                    throw new Error('Invalid Source: URL or SSAI is required');
                }
                type = (_c = this.source) === null || _c === void 0 ? void 0 : _c.mimeType;
                if (!type)
                    return [2];
                formatSupported = this.supportedFormats.isSupported({ type: type });
                if (!formatSupported) {
                    allowedMimeTypes = this.supportedFormats.manifest.flatMap(function (m) { return m.mimeTypes; });
                    allowedFormatted = allowedMimeTypes.join(', ') || 'none';
                    throw new Error("An unsupported media format (" + type + "). " +
                        ("Supported media formats are: " + allowedFormatted));
                }
                return [2];
            });
        });
    };
    PlayerBase.prototype.applySeekingRestriction = function (seekTime, currentTime, seekingRestriction) {
        if (currentTime === void 0) { currentTime = this.currentTime; }
        if (seekTime === currentTime) {
            return seekTime;
        }
        var finalRestriction = this.resolveSeekingRestriction(seekingRestriction !== null && seekingRestriction !== void 0 ? seekingRestriction : this.currentSeekingRestrictionKey);
        if (finalRestriction === types_1.SeekingRestriction.NO_SEEKING) {
            return currentTime;
        }
        if (finalRestriction === types_1.SeekingRestriction.NO_FORWARD &&
            seekTime > currentTime) {
            return currentTime;
        }
        return seekTime;
    };
    Object.defineProperty(PlayerBase.prototype, "currentSeekingRestrictionKey", {
        get: function () {
            var _a = this, currentAd = _a.currentAd, canSkipAd = _a.canSkipAd;
            if (!currentAd)
                return types_1.SeekingRestrictionKey.CONTENT_SEEK;
            if (canSkipAd)
                return types_1.SeekingRestrictionKey.SKIPPABLE_SEEK;
            if (currentAd.canRestart)
                return types_1.SeekingRestrictionKey.UNSKIPPABLE_SEEK;
            return types_1.SeekingRestrictionKey.DISABLED;
        },
        enumerable: false,
        configurable: true
    });
    PlayerBase.prototype.resolveSeekingRestriction = function (value) {
        var _a, _b, _c, _d;
        switch (value) {
            case types_1.SeekingRestriction.NO_FORWARD:
            case types_1.SeekingRestriction.NO_SEEKING:
            case types_1.SeekingRestriction.UNRESTRICTED:
                return value;
            case types_1.SeekingRestrictionKey.UNSKIPPABLE_SEEK:
                return ((_b = (_a = this.seekingRestrictions) === null || _a === void 0 ? void 0 : _a[value]) !== null && _b !== void 0 ? _b : types_1.SeekingRestriction.NO_FORWARD);
            case types_1.SeekingRestrictionKey.SKIPPABLE_SEEK:
            case types_1.SeekingRestrictionKey.CONTENT_SEEK:
                return ((_d = (_c = this.seekingRestrictions) === null || _c === void 0 ? void 0 : _c[value]) !== null && _d !== void 0 ? _d : types_1.SeekingRestriction.UNRESTRICTED);
            case types_1.SeekingRestrictionKey.DISABLED:
                return types_1.SeekingRestriction.NO_SEEKING;
            default:
                return types_1.SeekingRestriction.UNRESTRICTED;
        }
    };
    PlayerBase.prototype.isOnLiveEdge = function (time) {
        var timeToCheck = time || this.currentTime;
        return (this.live &&
            this.timeshiftRange &&
            this.timeshiftRange.end - timeToCheck <= ON_LIVE_EDGE_THRESHOLD);
    };
    PlayerBase.prototype.getContentTime = function (streamTime) {
        return streamTime;
    };
    PlayerBase.prototype.getStreamTime = function (time, seekType) {
        if (seekType === void 0) { seekType = types_1.SeekType.CONTENT_TIME; }
        var _a = this, live = _a.live, timeshiftRange = _a.timeshiftRange;
        var finalTime = time;
        if (seekType === types_1.SeekType.TIMESHIFT && live) {
            finalTime = time + timeshiftRange.end;
        }
        if (seekType === types_1.SeekType.UTC && live) {
            finalTime = time - Date.now() + timeshiftRange.end;
        }
        return finalTime;
    };
    PlayerBase.prototype.getEmptyTextTrack = function (selected) {
        return {
            id: exports.EMPTY_TRACK_ID,
            selected: selected,
            language: 'Off',
            label: 'off',
            kind: types_1.TrackKind.Empty,
            default: false,
            forced: false,
            type: types_1.TrackType.Text,
        };
    };
    PlayerBase.prototype.getState = function () {
        return this.state;
    };
    PlayerBase.prototype.onCanPlay = function () { };
    PlayerBase.prototype.onError = function (error) {
        var playerError;
        if (error instanceof types_1.PlayerError) {
            playerError = error;
        }
        else if (error instanceof Error) {
            playerError = new types_1.PlayerError({
                code: types_1.ErrorCodes.PLAYER_FAILURE,
                message: error.message,
                source: this.source,
                nativeCode: error.name,
                engine: this.getPlayerName(),
                engineVersion: this.getVersion(),
            });
        }
        else if ('code' in error && 'message' in error) {
            playerError = new types_1.PlayerError(error);
        }
        else {
            playerError = new types_1.PlayerError({
                code: types_1.ErrorCodes.PLAYER_FAILURE,
                message: String(error),
                source: this.source,
                engine: this.getPlayerName(),
                engineVersion: this.getVersion(),
            });
        }
        this.state = PlayerStates_1.PlayerStates.ERROR;
        this.logger.error(playerError.message, playerError);
        this.triggerEvent('error', {
            error: playerError,
        });
        this.unload();
    };
    PlayerBase.prototype.isMetadataLoaded = function () {
        return this.hasLoadedMetadata;
    };
    return PlayerBase;
}());
exports.PlayerBase = PlayerBase;
//# sourceMappingURL=PlayerBase.js.map